var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCompartir = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 800,
  height: 800,
  fill: "none",
  stroke: "#fff",
  viewBox: "0 0 24 24",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.836 16.13 9.026 12.2l-.75 1.299 6.81 3.932zM15.836 7.866l-6.81 3.932-.75-1.3 6.81-3.931z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.85 9.15a3.15 3.15 0 1 0 0-6.3 3.15 3.15 0 0 0 0 6.3ZM9.3 11.994a3.15 3.15 0 1 1-6.3 0 3.15 3.15 0 0 1 6.3 0ZM21 17.996a3.15 3.15 0 1 0-6.3 0 3.15 3.15 0 0 0 6.3 0Z"
}))));
export { SvgCompartir as ReactComponent };
export default __webpack_public_path__ + "assets/images/compartir.svg";